import React, { useEffect, useState } from "react";
import PageTitle from "../../../components/pageTitle/PageTitle";
import {
  Box,
  Checkbox,
  IconButton,
  Menu,
  MenuItem,
  TableCell,
  TableRow,
} from "@mui/material";
import TableDesign, {
  TableHeading,
} from "../../../components/common/table/TableDesign";
import { MoreVert as MoreIcon } from "@mui/icons-material";
import { Lens } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  addVehicleServicePaid,
  deleteVehicleService,
  deleteVehicleServiceSuccess,
  getVehicleServiceHistory,
  setAddVehicleServiceHistory,
  setVehicleServicePaid,
} from "../../../store/reducers/vehicleSlice";
import ManageVehicleService from "./service/ManageVehicleService";
import dayjs from "dayjs";
import ManageServicePayment from "./service/ManageServicePayment";
import DeleteAlert from "./service/DeleteAlert";

interface VehicleServiceHistoryProps {
  selectedId: string | number; // Adjust type as needed
}
interface FilterOption {
  page: number;
  limit: number;
  orderBy: string;
  orderIn: string;
}

const VehicleServiceHistory = ({ selectedId }: VehicleServiceHistoryProps) => {
  const tableHeadings: TableHeading[] = [
    { label: "#", align: "left" },
    { label: "Date", align: "left" },
    { label: "Title", align: "left" },
    { label: "Cost (£)", align: "left" },
    { label: "Paid", align: "center" },
    { label: "Action", align: "center" },
  ];
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [alertPaymentModelShow, setAlertPaymentModelShow] = useState(false);
  const [alertDeleteModelShow, setAlertDeleteModelShow] = useState(false);
  const openDown = Boolean(anchorEl);
  const [open, setOpen] = useState(false); // State variable to manage dialog open/close
  const {
    vehicleServiceHistory,
    isAddVehicleServiceHistory,
    isVehicleServicePaid,
    isVehicleServiceDeleted,
    vehServiceHistPaginationData,
  } = useSelector((state: any) => state.vehicle);
  const { userProfile } = useSelector((state: any) => state?.user);
  const [filterOption, setFilterOption] = useState<FilterOption>({
    page: 1,
    limit: 10,
    orderBy: "created_at",
    orderIn: "DESC",
  });
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (selectedId) {
      dispatch(getVehicleServiceHistory({ selectedId, ...filterOption }));
    }
  }, [selectedId, filterOption]);

  useEffect(() => {
    if (
      isAddVehicleServiceHistory ||
      isVehicleServicePaid ||
      isVehicleServiceDeleted
    ) {
      if (selectedId) {
        dispatch(getVehicleServiceHistory({ selectedId, ...filterOption }));
      }
      dispatch(setAddVehicleServiceHistory(false));
      dispatch(setVehicleServicePaid(false));
      dispatch(deleteVehicleServiceSuccess(false));
      setAlertPaymentModelShow(false);
      setAlertDeleteModelShow(false);
      setSelectedRow(null);
      setOpen(false);
    }
  }, [
    isAddVehicleServiceHistory,
    isVehicleServicePaid,
    isVehicleServiceDeleted,
  ]);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleEditOpen = () => {
    setAlertPaymentModelShow(true);
    handleClose();
  };

  const handleDeleteOpen = () => {
    setAlertDeleteModelShow(true);
    handleClose();
  };

  const handleConfirmPayment = () => {
    console.log("selectedRow,selectedId", selectedRow, selectedId);
    if (selectedRow && selectedId) {
      dispatch(
        addVehicleServicePaid({
          record_id: selectedRow.id,
          vehicle_id: selectedId,
        })
      );
    }
    setAlertPaymentModelShow(false);
  };

  const handleDeleteService = () => {
    console.log("selectedRow", selectedRow);
    if (selectedRow) {
      dispatch(deleteVehicleService(selectedRow.id));
    }
    setAlertDeleteModelShow(false);
  };

  return (
    <>
      {alertDeleteModelShow && (
        <DeleteAlert
          open={alertDeleteModelShow}
          onHide={() => setAlertDeleteModelShow(false)}
          title="Delete Service"
          alertModalShow={alertDeleteModelShow}
          setAlertModelShow={setAlertDeleteModelShow}
          onConfirm={() => handleDeleteService()}
        />
      )}
      {alertPaymentModelShow && (
        <ManageServicePayment
          open={alertPaymentModelShow}
          onHide={() => setAlertPaymentModelShow(false)}
          alertModalShow={alertPaymentModelShow}
          setAlertModelShow={setAlertPaymentModelShow}
          onConfirm={handleConfirmPayment}
        />
      )}
      {open && (
        <ManageVehicleService
          open={open}
          onHide={() => setOpen(false)}
          title="Add Service"
          selectedVehicleId={selectedId}
          selectedService={{}}
        />
      )}
      <section style={{ marginTop: "20px" }}>
        <PageTitle
          title="Vehicle Service History"
          button="Add Service"
          onClick={handleOpen}
        />
        <Box
          sx={{
            bgcolor: "#fff",
            height: { xs: "auto", sm: "60vh" },
            border: "1px solid #d1cfcf",
            borderRadius: "5px",
            padding: "0px",
            overflow: "hidden",
          }}
        >
          <TableDesign
            tableHeadings={tableHeadings}
            tableHeadColor={"#02906f"}
            cellColor={"#fff"}
            pagination={vehServiceHistPaginationData}
            isLoader={false}
            stickyHeader={true}
            filterOption={filterOption}
            setFilterOption={setFilterOption}
            // extraCSS={{
            //   height: "calc(100%)",
            // }}
          >
            {vehicleServiceHistory.length > 0 ? (
              vehicleServiceHistory?.map((val: any, idx: number) => (
                <TableRow
                  key={val?.id}
                  sx={{
                    cursor: "pointer",
                    marginTop: "10px",
                    padding: "4px !important",
                    borderRadius: "20px !important",
                    height: "36px",
                    "&:hover": {
                      backgroundColor: "#f0f0f0",
                      outline: "2px solid #f0f0f0",
                      borderRadius: "0px !important",
                      outlineOffset: "-2px !important",
                    },
                  }}
                >
                  <TableCell align="left">{idx + 1}</TableCell>
                  <TableCell>
                    {val?.date
                      ? dayjs(val?.date)?.format(
                          userProfile?.dateFormat ?? "DD/MM/YYYY"
                        )
                      : null}
                  </TableCell>
                  <TableCell>{val?.title}</TableCell>
                  <TableCell>{val?.cost ? `£ ${val?.cost}` : null}</TableCell>
                  <TableCell align="center">
                    <Checkbox checked={val?.is_paid} />
                  </TableCell>
                  <TableCell align="center" sx={{ padding: "0px" }}>
                    {!val?.is_paid && (
                      <IconButton
                        sx={{ padding: "0px" }}
                        size="small"
                        id="basic-button"
                        aria-controls={openDown ? "basic-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={openDown ? "true" : undefined}
                        onClick={(e) => {
                          handleClick(e);
                          setSelectedRow(val);
                        }}
                      >
                        <MoreIcon />
                      </IconButton>
                    )}
                    <Menu
                      sx={{
                        boxShadow: "none",
                        border: "2px solid #eeecef",
                        "& .MuiPaper-root": {
                          boxShadow: "none", // Removes shadow on the paper element of the menu
                          border: "2px solid #eeecef",
                        },
                        top: "0px",
                      }}
                      // className={classes.menuBox}
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={openDown}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      <MenuItem onClick={() => handleEditOpen()}>
                        <Lens
                          style={{
                            height: "4px",
                            width: "4px",
                            marginRight: "4px",
                          }}
                        />
                        Make a paid
                      </MenuItem>

                      <MenuItem onClick={() => handleDeleteOpen()}>
                        <Lens
                          style={{
                            height: "4px",
                            width: "4px",
                            marginRight: "4px",
                          }}
                        />
                        Delete
                      </MenuItem>
                    </Menu>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7}>
                  <Box
                    sx={{
                      height: "60vh",
                      display: "flex",
                      // alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        fontSize: "1rem",
                        color: "#4A4A4A",
                        top: "100px",
                      }}
                    >
                      {"No Vehicle Service History Found."}
                    </span>
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableDesign>
        </Box>
      </section>
    </>
  );
};

export default VehicleServiceHistory;
